export default "__VITE_ASSET__FsLj4pCY__";